module.exports = __webpack_public_path__ + "img/05.507782d4.png";